const initialState = {
  loading: false,
  releaseNotes: [],
};

export default initialState;
